// extracted by mini-css-extract-plugin
export default {"options":"Options_options__agIu1","option":"Options_option__HuBIm"};